import(/* webpackMode: "eager" */ "/codebuild/output/src613930504/src/apps/junonkuji/src/app/error.tsx");
